export default "__VITE_ASSET__DJaCU5Qw__"